import {KbEventRecord} from "@kta20-knowledge-base/models/kb-event-record";

export class KbDocumentRecord extends KbEventRecord{

    static CLASS_NAME='KbDocumentRecord';

    static fromJSON(jsonObj:any):KbDocumentRecord{
        jsonObj.pages = jsonObj.pages.map(it => Object.assign(new KbDocumentPage(),it));
        return Object.assign(new KbDocumentRecord(), jsonObj);
    }

    readonly type:string=KbDocumentRecord.CLASS_NAME;

    public numPages:number;

    public url:string;

    public pages:KbDocumentPage[];

}

export class KbDocumentPage {

    public number:number;
    public url:string;
    public text:string;
    public rate:number=0;

}